import { render, staticRenderFns } from "./FieldSection.vue?vue&type=template&id=5b61d8a2&name=field-section&"
import script from "./FieldSection.vue?vue&type=script&lang=js&"
export * from "./FieldSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports